const url = '/travel-agent-types';
const Provider = 'TravelAgentTypes';
const dbModel = 'TravelAgentTypes';

export { url, Provider, dbModel };
